import { lazy } from 'react';
import { Trans } from 'react-i18next';

import styles from './api-error-block.module.scss';

const Button = lazy(() => import('core/generic/elements/button'));
const InfoBlock = lazy(() => import('core/generic/elements/info-block'));

type ApiErrorBlockProps = {
	apiErrorMessage: string;
};

export const ApiErrorBlock = ({ apiErrorMessage }: ApiErrorBlockProps) => {
	if (!apiErrorMessage) return null;

	return (
		<InfoBlock variant="error">
			<div className={styles['error-info-block']}>
				<p className="body-small">
					<Trans
						i18nKey={apiErrorMessage}
						components={[
							<Button
								variant="link"
								dimension="medium"
								className={styles['inline-button']}
							/>,
						]}
					/>
				</p>
			</div>
		</InfoBlock>
	);
};

export default ApiErrorBlock;
